module.exports = __webpack_public_path__ + "img/智慧建设.b2958477.png";